import { getImgeUrl } from 'src/environments/environment';
import { CommonModule, NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PaginationComponent } from 'src/app/admin/pagination/pagination.component';
import { AdminUserService } from 'src/app/admin/components/admin-user/admin-user.service';
import { ThemeCustomizerService } from 'src/app/components/common/theme-customizer/theme-customizer.service';


@Component({
  selector: 'app-event-list',
  standalone: true,
  imports: [NgFor, RouterModule, ReactiveFormsModule, PaginationComponent, CommonModule],
  templateUrl: './event-list.component.html',
  styleUrl: './event-list.component.scss'
})
export class EventListComponent {

  events
  filter_form: FormGroup
  language = 1
  languages:any
  page = 1
  number_of_page = 1
  paginatedData: any[];
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalItems: number;
  totalPages
  imageUrl = getImgeUrl()
  filter:any = {
    "title":"",
    "page": 1, 
    "lang": this.language
  }
  isToggled = false;

  category
  constructor(private userService: AdminUserService, private toaster: ToastrService,
    private adminService: AdminService,
    private formBuilder: FormBuilder,
    public themeService: ThemeCustomizerService, 
    private activeRouter: ActivatedRoute
  ) {
    this.itemsPerPage = this.adminService.ITEM_PERPAGE
    this.themeService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
    });


  }

	

  toggleTheme() {
      this.themeService.toggleTheme();
  }


  ngOnInit(): void {

    this.createFilterForm()
    this.getLanguage()
    this.getDate()

  }

  getLanguage() {
    this.languages = this.adminService.getWebsiteLanguages()
  }



  onPageChange(page: number): void {
    this.currentPage = page;
    this.filter["page"] = page
    this.getDate();
  }


  createFilterForm() {
    this.filter_form = this.formBuilder.group({
      title:["", Validators.pattern(/^[a-zA-Z0-9]*$/)],
    })
  }

  applyFilter() {
    if(this.filter_form.invalid) return 
    const data = this.filter_form.value

    this.filter = {
      "title": data.title? data.title:"",
      "page": 1, 
      "lang": this.language
    }

    

    this.getDate()

    

  }

  resetFilter() {
    this.filter_form.reset()
    this.filter.title = ""
    this.getDate()
  }
  getDate() {
    this.adminService.getRecordList(this.adminService.EVENT_URL, this.filter).subscribe({
      next: (res) => {
        this.events = res["data"]
        this.totalItems = res["total_records"]
        console.log("page", this.number_of_page)

      },
      error: (error) => {
        console.error("here goes the Unexpected error:", error);
      }
    })
  }
}
